module.exports = __webpack_public_path__ + "img/wechatPublisher.3c58b206.png";